import { Component, OnInit } from '@angular/core';
import { IBankAccount } from './../models/bank-account.model';
import bankAccounts from '../../assets/data/bank-accounts.json';


@Component({
  selector: 'app-demo',
  templateUrl: './demo.component.html',
  styleUrls: ['./demo.component.scss']
})
export class DemoComponent implements OnInit {

  myBankAccounts:IBankAccount[] = [];
  bankAccountString:string;

  constructor() { }

  ngOnInit() {
    this.myBankAccounts = bankAccounts;

    this.bankAccountString = JSON.stringify(this.myBankAccounts, undefined, 4);
    // var myJson = JSON.parse(this.bankAccountString);
    // myJson.body = myJson.body.replace(/\n/g, "<br />");
    //this.bankAccountString = this.bankAccountString.replace('/n',"<br/>");
    //json.body = body = json.body.replace(/\n/g, "<br />");
  }

}
